import styled, { css } from "styled-components";
import { device } from "../../themes/Breakpoints";


export const Wrapper = styled.section`
  &.main-container {
    margin-top: 40px;
    margin-bottom: 68px;
  }
  @media only screen and (max-width: 1249px) {
    margin-bottom: 40px;
  }
`;

export const AccordionWrapper = styled.article`
  margin-bottom: 24px;
`;

export const TeamSummary = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  width: 100%;
  @media only screen and (max-width: 1249px) {
   gap: 10px;
  }
  @media ${device.tabletL} {
    width:60%;
  }
  @media ${device.tablet} {
    width:60%;
  }
 
`;
export const TeamInfo = styled.div`
  background-color: ${({ bgColor }) => (bgColor ? bgColor : "white")};
  display: flex;
  align-items: center;
  padding: 8px 16px;
  gap: 27px;
  border-radius: 4px 0px 0px 4px;
  width: 166px;
  .tema-info-name {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    color: #fff;
    &-loc {
      font-weight: 700;
      font-size: 20px;
      line-height: 30px;
      letter-spacing: 0.01em;
      text-transform: capitalize;
    }
    &-need {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0.01em;
      text-transform: capitalize;
    }
  }
  @media only screen and (max-width: 1249px) {
    gap: 10px;
    padding: 8px 8px;
  }
  @media ${device.mobileM} {
    width: 60%
  }
  @media ${device.mobileS} {
    width: 60%
  }
`;
export const ImgWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0;
  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-transform: capitalize;
    color: #fff;
  }
  img {
    width: 50px;
    height: 50px;
    display: block;
    object-fit: cover;
  }
`;

export const DraftPlayers =styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  justify-content: space-between;
  @media ${device.tabletL} {
    width:40%;
  }
  @media ${device.tablet} {
    width:40%;
  }
  
`
export const TeamPosition = styled.ul`
  display: flex;
  align-items: center;
  width: 100%;
  @media ${device.mobileM} {
   flex-wrap:wrap
  }
  @media ${device.mobileS} {
    flex-wrap:wrap
  }
`;

export const TeamDraftCount = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
  width: 200px;
  .draft-title{
    display: flex;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: rgb(0, 78, 163);
    white-space: nowrap;
  }
  .draft-count{
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: rgb(0, 78, 163);
  }
  @media only screen and (max-width:767px) {
    width: 50%;
    align-items: flex-start;
    flex-direction:unset;
    gap: 10px;
    justify-content: flex-start;
  }
  @media ${device.tabletL} {
    align-items: flex-start;
    width: 50%;
  }
  @media ${device.tablet} {
    align-items: flex-start;
    width: 50%;
  }
  @media ${device.mobileS} {
    flex-direction:column;
    align-items: center;
    gap: 2px;
  }
  @media ${device.mobileM} {
    width: 45%;
  }
  @media ${device.mobileS} {
    width: 45%;
  }
`;
export const TeamPositionItem = styled.li`
  padding: 16px;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #3e464f;
  ${(props) =>
    props.primary &&
    css`
      color: #004ea3;
    `};
  @media only screen and (max-width: 1249px) {
    padding: 8px;
  }
  @media ${device.mobileL} {
    justify-content: center;
    padding: 2px;
  }
  @media ${device.mobileM} {
    justify-content: center;
    padding: 2px;
  }
  @media ${device.mobileS} {
    justify-content: center;
    padding: 2px;
  }
`;

export const PlayerList = styled.div`
  width: 300px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 48px;
  gap: 8px;

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;
    color: #004ea3;
  }
  @media only screen and (max-width: 1249px) {
    margin-right: 8px;
    width: 25%;
  }
  @media only screen and (max-width:767px) {
    width: 50%;
  }
  @media ${device.tabletL} {
    width: 50%;
  }
  @media ${device.tablet} {
    width: 50%;
  }
  @media ${device.mobileM} {
    width: 45%;
  }
  @media ${device.mobileS} {
    width: 45%;
  }
`;
